module.exports = __webpack_public_path__ + "img/goods1.de107d1d.jpg";